import React from 'react';
import ReactPaginate from 'react-paginate';

const CustomReactPaginate = ({
  totalPages,
  page,
  pageRangeDisplayed,
  marginPagesDisplayed,
  onPageChange,
}) => {
  return (
    <div className="row">
      <div className="col-md-6 text-center mx-auto mt-4">
        <ReactPaginate
          pageCount={totalPages}
          pageRangeDisplayed={pageRangeDisplayed}
          marginPagesDisplayed={marginPagesDisplayed}
          forcePage={page}
          onPageChange={onPageChange}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          nextClassName="page-item"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextLinkClassName="page-link"
          containerClassName="pagination pagination-sm justify-content-center"
          activeClassName="active"
          breakLabel={'...'}
          nextLabel=">>"
          previousLabel="<<"
        />{' '}
      </div>
    </div>
  );
};

export default CustomReactPaginate;
